import { Button, Toast, ToastContainer } from "react-bootstrap";
import { useShopContext } from "../../context/ShopContext";
import { BsTrash } from "react-icons/bs";

interface DeletionToastProps {
    itemCode: number;
    onClose: ()=>void;
}
const DeletionToast = ({ itemCode, onClose }: DeletionToastProps) => {

    const { deleteFromCart } = useShopContext();

    return (
        <ToastContainer position="middle-center" className="position-absolute" style={{zIndex: 1}}>
            <Toast className="toast-background">
                <Toast.Header closeButton={false} className="bg-dark text-light">
                <BsTrash size="20px" className="text-light me-2" />
                    Επιβεβαίωση διαγραφής
                </Toast.Header>
                <Toast.Body>
                    <p>Να διαγραφεί το προϊόν από το καλάθι;</p>
                    <div className="d-flex justify-content-around">
                        <Button className="border-0 bg-success text-light" onClick={() => {
                            deleteFromCart(Number(itemCode));
                        }}>Ναι</Button>
                        <Button className="border-0 bg-danger" onClick={onClose}>Όχι</Button>
                    </div>
                </Toast.Body>
            </Toast>
        </ToastContainer>
    );
};

export default DeletionToast;